var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/thumbUp-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2427 7.08348C17.6391 7.08348 17.9893 7.2355 18.2931 7.53953C18.5972 7.84341 18.7492 8.19355 18.7492 8.58994V9.93598C18.7492 10.0225 18.7401 10.116 18.7219 10.2164C18.7037 10.3168 18.6765 10.4104 18.6402 10.497L16.2523 16.1316C16.1327 16.3987 15.9324 16.6241 15.6515 16.8079C15.3705 16.9916 15.0783 17.0835 14.7748 17.0835H8.02794C7.61238 17.0835 7.25745 16.9363 6.96314 16.642C6.66884 16.3476 6.52169 15.9926 6.52169 15.577V7.70682C6.52169 7.50598 6.5628 7.31293 6.64502 7.12765C6.72724 6.94223 6.83676 6.78112 6.97356 6.64432L11.3821 2.26453C11.5478 2.10758 11.7396 2.01091 11.9575 1.97453C12.1754 1.93828 12.3843 1.97085 12.584 2.07223C12.7838 2.17376 12.9281 2.32279 13.0167 2.51932C13.1054 2.71598 13.1231 2.92487 13.0696 3.14598L12.1721 7.08348H17.2427ZM3.58898 17.0835C3.17342 17.0835 2.81842 16.9363 2.52398 16.642C2.22967 16.3476 2.08252 15.9926 2.08252 15.577V8.58994C2.08252 8.17439 2.22967 7.81939 2.52398 7.52494C2.81842 7.23064 3.17342 7.08348 3.58898 7.08348H3.76523C4.18078 7.08348 4.53578 7.23064 4.83023 7.52494C5.12453 7.81939 5.27169 8.17439 5.27169 8.58994V15.5851C5.27169 16.0007 5.12453 16.3543 4.83023 16.646C4.53578 16.9376 4.18078 17.0835 3.76523 17.0835H3.58898Z",
    fill: "#008A94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpFill);
export default __webpack_public_path__ + "static/media/thumb-up-fill.a819d71afa823a490bd753ccfa796b4a.svg";
export { ForwardRef as ReactComponent };